// Copyright (c) 2023, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 Inc. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import React from "react";
import { Box, Typography } from "@mui/material";
import {
  Link as RouterLink,
  LinkProps as RouterLinkProps,
} from "react-router-dom";
import maintenanceImg from "../assets/img/maintenance.gif";

const Link = React.forwardRef<HTMLAnchorElement, RouterLinkProps>(function Link(
  itemProps,
  ref
) {
  return <RouterLink ref={ref} {...itemProps} role={undefined} />;
});

export default function MaintenancePage() {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      <Typography style={{ color: "#ff7300", fontSize: 30, fontWeight: 550 }}>
        Certification Portal
      </Typography>
      <img alt="maintenance" src={maintenanceImg} style={{ width: "40%" }} />
      <Typography style={{ color: "gray", fontSize: 20 }}>
        The Certification Portal is currently undergoing scheduled maintenance
        and is temporarily unavailable.
      </Typography>
      <Typography style={{ color: "gray", fontSize: 20 }}>
        We apologize for any inconvenience and appreciate your patience.
      </Typography>
    </Box>
  );
}
